<dod-directory-filtering
  [search]="search"
  [categories]="categories"
  (onSearch)="emitChange({ search: $event })"
  (onSkillCategoryUpdated)="emitChange({ skill_categories: $event })" />

<dod-directory-sorting [sorting]="sorting" (onSortingChanged)="onSortingChanged($event)" />

<accredible-pagination
  class="pagination"
  [hideLabels]="true"
  [pageMeta]="currentRegionMetadata()"
  (pageChange)="onPageChange($event)" />
